import { inject, type InjectionKey, type Plugin } from 'vue'
import type { RetailChannel, RetailNotificationPosition } from '#src/plugins/types'
import type { RetailSdkOptions } from '#src/plugins/interfaces/RetailSdkOptions'

const RetailSdkOptionsKey: InjectionKey<Readonly<RetailSdkOptions>> = Symbol('RetailSdkOptions')

const defaultPositionByChannel: Record<RetailChannel, RetailNotificationPosition> = {
  pos: 'topMiddle',
  ssbt: 'bottomMiddle',
  sbo: 'topMiddle',
  playground: 'topMiddle'
}

export const createRetailSdkPlugin = (options: RetailSdkOptions): Plugin => ({
  install(app) {
    app.provide(RetailSdkOptionsKey, Object.freeze({ ...options }))
  }
})

export const useRetailSdkOptions = () => {
  const options = inject(RetailSdkOptionsKey)
  if (!options) {
    throw new Error('Retail SDK plugin is not installed')
  }

  return {
    options,
    notificationPosition:
      options.notificationPosition ?? defaultPositionByChannel[options.channel]
  }
}
